import React, { useEffect, useState } from 'react';
import { GetAlllogsApi } from "../../../api/request/logs";
import moment from "moment";
import { useSelector } from "react-redux";
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import Pagination from '../../../components/pagination/Pagination.jsx';
import columns from '../../../columns/UserLogs.js';

export default function Logs() {
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const { userDetails } = useSelector(state => state.user);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);

    const getAllIB = async () => {
        try {

            let params = {
                PageNumber: page,
                PageSize: pageSize,
                UserId: userDetails?.id
            }
            setIsLoading(true);
            const { data: response } = await GetAlllogsApi(params);
            if (response?.success) {
                setData(
                    response?.data?.map((item) => ({
                        ...item,
                        createdDate: moment(item?.timestamp).format('DD-MM-YYYY, hh:mm A'),
                    }))
                );
                setTotalRecord(response?.totalRecords);
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllIB();
    }, [page, pageSize]);

    return (
        <div>
            <div className='border border-gray-200 rounded-xl'>
                <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
            </div>
            <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
        </div>
    );
}
